import React from "react";
import styled from "styled-components";
import trimLeading from "@src/utils/trimLeading";
import { Props } from "./";
import settings from "@src/settings";
import getGridHeight from "@src/utils/getGridHeight";
import { down, only } from "styled-breakpoints";
import VoiceLead from "@src/components/VoiceLead";
import VoiceIntroImage from "../VoiceIntroImage";

export const Frame = styled.div<{ direction: Props["direction"] }>`
	display: flex;
	flex-direction: ${(props) =>
		props.direction == "fromLeft"
			? "row-reverse"
			: props.direction == "fromRight"
			? "row"
			: props.direction == "fromTop" && "column"};
	height: ${getGridHeight({ rows: 15 })}px;
	cursor: pointer;
	& > ${VoiceIntroImage} {
		${down("md")} {
			flex-basis: ${getGridHeight({ rows: 12 })}px;
			height: ${getGridHeight({ rows: 12 })}px;
			width: 100%;
			margin-bottom: ${getGridHeight({ rows: 2 })}px;
		}
		${down("xs")} {
			flex-basis: ${getGridHeight({ rows: 8 })}px;
			height: ${getGridHeight({ rows: 8 })}px;
			margin-bottom: ${getGridHeight({
				rows: 1,
				withTopGap: true,
				withBottomGap: true,
			})}px;
		}
	}
	${down("md")} {
		height: auto;
	}
`;
export const TextArea = styled.div`
	flex: 0 0 27rem;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: ${getGridHeight({ rows: 1, withBottomGap: true })}px 0;
	position: relative;
	& > ${VoiceLead} {
		align-self: stretch;
	}
	${only("lg")} {
		flex-basis: 50%;
	}
	${down("md")} {
		height: auto;
		flex-basis: auto;
		width: 100%;
		justify-content: flex-start;
		padding: ${getGridHeight({ rows: 2, withBottomGap: true })}px 0 0;
	}
	${down("xs")} {
		padding: ${getGridHeight({
				rows: 2,
			})}px
			0 0;
	}
`;
